module.exports = __webpack_public_path__ + "static/img/bg-id.80c63bf2.webp";